import React, { Fragment, useState } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MuiTable from '../../../features/MuiTable';
import cityData from '../../../data/city_tax_rates.json';
import CityTaxLineChart from '../../../components/CityTaxLineChart';

export default function CityTaxes() {
  const tableColumns = [
    { title: 'Year', field: 'year' },
    { title: 'County', field: 'county_name' },
    { title: 'City', field: 'taxing_unit_name' },
    { title: 'M & O Rate', field: 'm_o_tax_rate' },
    { title: 'I & S Rate', field: 'i_s_tax_rate' },
    { title: 'Total Tax Rate', field: 'total_tax_rate' },
    /*     { title: 'Fiber Qualified', field: 'currentFTTP', render: (rowData) => <YesNoIcon data={rowData} key='currentFTTP' value={rowData.currentFTTP} /> }, */
  ];

  console.log('city', cityData);
  return (
    <Grid container spacing={3}>
      {/* CityTaxLineChart */}
      {/* <Grid item xs={12} md={12} lg={12}>
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            height: 600,
          }}
        >
          <CityTaxLineChart chartTitle='City Tax Trends - Grand Saline' chartData={cityData.cityData} />
        </Paper>
      </Grid> */}

      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <MuiTable title='City Tax Rates' data={cityData.cityData} columns={tableColumns} edit={true} />
        </Paper>
      </Grid>
    </Grid>
  );
}
